export const PRIVILEGE_SA = 'SA';
export const PRIVILEGE_APP_WORKING_HOUR = 'APP_WR_HR';
export const PRIVILEGE_APP_DASHBOARD = 'APP_DASHB';
export const PRIVILEGE_APP_BI = 'APP_BI';
export const PRIVILEGE_APP_STATUS = 'APP_STATUS';
export const PRIVILEGE_APP_OF = 'APP_OF';
export const PRIVILEGE_APP_CAM = 'APP_CAM';
export const PRIVILEGE_APP_TASK = 'APP_TASK';
export const PRIVILEGE_APP_PURCHASING = 'APP_PLANNER_PURCH';
export const PRIVILEGE_APP_TECHNICAL_OFFICE = 'APP_PLANNER_OT';
export const PRIVILEGE_APP_QUALITY = 'APP_PLANNER_QUAL';
export const PRIVILEGE_APP_PRODUCTION = 'APP_PLANNER_PROD';
export const PRIVILEGE_APP_READINESS = 'APP_PLANNER_READINESS';
export const PRIVILEGE_APP_SIMULATE = 'APP_PLANNER_SIMULATE';
export const PRIVILEGE_APP_MASTER_TASK = 'APP_MAS_TAS';
export const PRIVILEGE_APP_CNC = 'APP_CNC';
export const PRIVILEGE_APP_CHECK_MACHINE = 'APP_CH_MACH';
export const PRIVILEGE_APP_CHECK_OPERATOR = 'APP_CH_OPER';
export const PRIVILEGE_APP_SIGNING_VALIDATION = 'APP_SIGN_VALID';
export const PRIVILEGE_APP_CHECK_TOOL = 'APP_CHECK_TOOL';
export const PRIVILEGE_ADMIN_CONTROL = 'ADMIN_CTRL';
export const PRIVILEGE_ADMIN_MACHINE = 'ADMIN_MACH';
export const PRIVILEGE_ADMIN_MACHINE_GROUP = 'ADMIN_MACH_GROUP';
export const PRIVILEGE_ADMIN_TOOL = 'ADMIN_TOOL';
export const PRIVILEGE_ADMIN_REFRIGRETAION = 'ADMIN_REFR';
export const PRIVILEGE_ADMIN_USERS = 'ADMIN_USERS';
export const PRIVILEGE_ADMIN_CALENDAR = 'ADMIN_CLDR';
export const PRIVILEGE_ADMIN_BOM = 'ADMIN_BOM';
export const PRIVILEGE_ADMIN_CAM = 'ADMIN_CAM';
export const PRIVILEGE_ADMIN_OF = 'ADMIN_OF';
export const PRIVILEGE_ADMIN_BI = 'ADMIN_BI';
export const PRIVILEGE_ADMIN_PRESETTING = 'ADMIN_PRESETTING';
export const PRIVILEGE_APP_VISUALIZATOR = 'APP_VIS';
export const PRIVILEGE_APP_MAINTENANCE = 'APP_MAINT';
export const PRIVILEGE_APP_TM_TOOL = 'APP_TM_TOOL';
export const PRIVILEGE_APP_TM_ORDER_REQUEST = 'APP_TM_ORDER_REQUEST';
export const PRIVILEGE_APP_TM_PENDING_ORDERS = 'APP_TM_PENDING_ORDERS';
export const PRIVILEGE_APP_TM_VALIDATE_RECONSTRUCTION = 'APP_TM_VALIDATE_RECONSTRUCTION';
export const PRIVILEGE_APP_TM_SEND_ERP = 'APP_TM_SEND_ERP';
export const PRIVILEGE_APP_TM_HISTORICAL = 'APP_TM_HISTORICAL';
export const PRIVILEGE_APP_ASSISTANT = 'APP_ASSIST';




// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/config/privileges.config.ts